/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { t } from 'i18next';
import cn from 'classnames';
import { Dropdown } from '@ui-modules/informed';
import { IDropdownOption } from '@ui-modules/types';
import { notEmptyValidator } from '@common/utils';
import css from '../styles.module.scss';

interface IVehicleKeyField {
  returnTrip?: boolean;
  vehiclesOptions: IDropdownOption[];
  multilegField?: string;
}

const VehicleKeyField: FC<IVehicleKeyField> = ({ returnTrip, vehiclesOptions, multilegField }) => (
  <div className={css.field} data-testid="mobility-planner-edit-form-vehicle">
    <Dropdown
      className={cn('dark-border', 'small-list')}
      label={t('common.vehicle')}
      labelClassName={css['dropdown-label']}
      name={multilegField ? `${multilegField}.vehicle` : returnTrip ? 'vehicle_return' : 'vehicle'}
      options={vehiclesOptions}
      validate={notEmptyValidator}
    />
  </div>
);

export default VehicleKeyField;
